import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  //进度查询
  getCheckList: {
    url: '/adminc/v1/organization_manage/o_company_apply/get_check_list',
    method: 'get'
  },
  //删除
  deleteSettledCompany: {
    url: '/adminc/v1/organization_manage/o_company_apply/delete_settled_company',
    method: 'delete'
  },
  //获取验证码
  getValidateCode: {
    url: '/adminc/v1/organization_manage/o_company_apply/create_validate',
    method: 'post'
  }
}
export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/Login/LookPro.js